export default __webpack_public_path__ + "static/InterDisplay-ExtraBold-0ba6db385cb51c1e7478fe616dbed852.woff2";